import { TooltipIcon } from "PFComponents/tooltip";
import { useTranslation } from "react-i18next";

const ExceptionsWarning = () => {
  const { t } = useTranslation("auditPlanner");

  return (
    <TooltipIcon
      iconName="error"
      iconProps={{ color: "paletteRed0" }}
      content={t("modals.actions.undoMessage")}
    />
  );
};

export default ExceptionsWarning;
